import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { ApiVisa } from '../../shared';
import { StatementOfAccountRunHdrModel } from "../../../../../../models/aggregates/erp/statement-of-account/statement-of-account-run-hdr.model";

@Injectable({ providedIn: "root" })
export class StatementOfAccountRunHdrService extends BaseApiTemplateService<StatementOfAccountRunHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
    "hdrs/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "hdrs/backoffice-ep";
    this.httpClient = theHttp;
  }

  printPdf(guid: string, apiVisa: ApiVisa) {
    return this.httpClient.get<Blob>(
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "hdrs/" + "print/" + "backoffice-ep/" + guid,
      this.getHttpHeaderBlob(apiVisa)
    )
  }

  sendEmails(guid: string, apiVisa: ApiVisa) {
    return this.httpClient.post(
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.STATEMENT_OF_ACCOUNT_PREFIX +
      "hdrs/" + "email/" + "backoffice-ep/" + guid, null, this.getHttpHeader(apiVisa))
  }
}
